const deviceCategory = new Map()
deviceCategory.set('锅炉', '1000')
deviceCategory.set('压力容器', '2000')
deviceCategory.set('电梯', '3000')
deviceCategory.set('起重机械', '4000')
deviceCategory.set('场（厂）内专用机动车辆', '5000')
deviceCategory.set('大型游乐设施', '6000')
deviceCategory.set('压力管道元件', '7000')
deviceCategory.set('压力管道', '8000')

export default deviceCategory
